import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default BaseChannelSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    commandSteps: {
      embedded: 'always'
    }
  },
  modelNameFromPayloadKey() {
    return 'channels/command';
  },
  serialize(snapshot) {
    const json = {
      command_name: snapshot.record.commandName,
      parent_id: Number.parseInt(snapshot.record.parentId, 10),
      command_payload: {
        ...snapshot.record.payload
      }
    };
    return json;
  }
});